// store/authSlice.js
import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  accessToken: null,
  user: {
    email: null,
    role: null,
    active: null
  },
}


const loadState = () => {
  try {
    const accessToken = localStorage.getItem("jwtToken");
    const user = JSON.parse(localStorage.getItem("userData"))?.user || { email: null, role: null };
    return {
      accessToken,
      user,
    };
  } catch (err) {
    return initialState;
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState: loadState(),
  reducers: {
    loginSuccess(state, action) {
      state.accessToken = action.payload.accessToken;
      state.user = action.payload.user;
    },
    logout(state) {
      localStorage.removeItem("jwtToken")
      localStorage.removeItem("refreshToken")
      localStorage.removeItem("userData")
      state.accessToken = '';
      state.user = {
        email: '',
        role: '',
      };
    },
    toggleUser: (state, action) => {
      // console.debug('TOGGLE', Number(!state.user.active))
      state.user.active = Number(!state.user.active)
    },
  },
});

export const { loginSuccess, logout, toggleUser } = authSlice.actions
export default authSlice.reducer
